import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const Pengajuan = ({
  number, nama, npm, prodi, url,
}) => (
  <tr>
    <td>
      {' '}
      {number}
      {' '}
    </td>
    <td>
      {nama}
      {' '}
    </td>
    <td>
      {' '}
      {npm}
      {' '}
    </td>
    <td>
      {' '}
      {prodi}
      {' '}
    </td>
    <td>
      <Button style={{ margin: 0 }} href={url}>
        Lihat
      </Button>
    </td>
  </tr>
);

Pengajuan.propTypes = {
  number: PropTypes.number,
  npm: PropTypes.string,
  prodi: PropTypes.string,
  nama: PropTypes.string,
  url: PropTypes.string,
};

Pengajuan.defaultProps = {
  number: 0,
  nama: '',
  url: '',
  npm: '',
  prodi: '',
};

export default Pengajuan;
